import { jsx as _jsx } from "react/jsx-runtime";
import stackblitz from '@stackblitz/sdk';
import { useEffect } from 'react';
export const StackBlitzEmbed = ({ contentInfo }) => {
    const containerId = `stackblitz-embed-${contentInfo.projectId}`;
    useEffect(() => {
        try {
            stackblitz.default.embedProjectId(containerId, contentInfo.projectId, {
                height: 500,
                width: '100%',
            });
        }
        catch {
            // Do nothing
        }
    });
    return (_jsx("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        }, children: _jsx("div", { id: containerId }) }));
};
//# sourceMappingURL=StackBlitzEmbed.js.map